import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { HttpClient } from '@angular/common/http';
import { serverurl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(
    private http: HttpClient,
    private snack: SnackService,
  ) { }

  async createTag(name: string, tagGroupId: string, icon: string) {
    return await new Promise((resolve) => {
      this.http.post(serverurl + '/tags', { name, tagGroupId, icon }).subscribe({
        next: (data: any) => {
          resolve(true)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
  async updateTag(id: string, name: string, tagGroupId: string, icon: string) {
    return await new Promise((resolve) => {
      this.http.put(serverurl + '/tags/' + id, { name, tagGroupId, icon }).subscribe({
        next: (data: any) => {
          resolve(true)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
  async deleteTag(id: string) {
    return await new Promise((resolve) => {
      this.http.delete(serverurl + '/tags/' + id).subscribe({
        next: (data: any) => {
          resolve(true)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
}
